import styled from "@emotion/styled";

export const ColorIndicator = styled.div`
  height: 20px;
  min-width: 20px;
  margin-left: 5px;
  border-radius: 0.25rem;
  background-color: #ffffff;
  &:hover {
    cursor: pointer;
  }
`;

export const DesktopSelectorWrapper = styled.div`
  display: flex;
  gap: 10px;
  max-width: 100%;
  margin-top: 0.3125rem;
`;

export const InputWrapper = styled.div`
  background-color: #f4f4f4;
  padding: 10px;
  border-radius: 0.875rem;
  display: flex;
  align-items: center;
  gap: 7.5px;
  max-width: 100%;
  &.color {
    width: 62.5%;
  }
  &.alpha {
    width: 35%;
    padding-left: 17.5px;
  }
`;

export const Input = styled.input`
  border: none;
  font-family: "Poppins", sans-serif;
  background: transparent;
  width: 100%;
  font-size: 12px;
  font-weight: 500;
  outline: none !important;
  border: none !important;
  box-shadow: none !important;
  &:focus,
  &:active {
    outline: none !important;
    border: none !important;
    box-shadow: none !important;
  }
`;

export const Button = styled.button`
  border: none;
  background-color: transparent;
  color: grey;
  font-size: 12px;
`;

export const Icon = styled.i`
  margin-right: 5px;
  color: grey;
  font-size: 12px;
`;

export const MobileSelectorWrapper = styled.div`
  position: relative;
  margin-bottom: 10px;
  label {
    font-size: 12px;
  }
  & > .toggle-buttons {
    margin-top: 5px;
    padding: 0px;
    height: 40px;
    background-color: #f4f4f4;
    border-radius: 0.875rem;
    div {
      width: 100%;
      height: 40px;
      button {
        font-size: 12px;
        height: 30px;
        display: flex;
        align-items: center;
        border-radius: 8px;
      }
    }
  }
`;

export const MobileColorPickerWrapper = styled.div`
  width: 100%;
  padding: 0px !important;
  .sketch-picker {
    min-width: 100% !important;
    padding: 0px !important;
    display: flex;
    flex-direction: column;
    width: 98% !important;
    box-shadow: none !important;
    max-width: 100% !important;

    & > div:last-of-type,
    & > :nth-of-type(3) {
      display: none !important;
    }

    /* Target the container with position relative and padding-bottom */
    & > div:first-of-type {
      max-height: 130px;
      padding-bottom: 0 !important;
      height: 130px;
    }

    /* Target the saturation-white div */
    & .saturation-white {
      position: absolute;
      inset: 0;
    }

    /* Target the saturation-black div */
    & .saturation-black {
      position: absolute;
      inset: 0;
    }

    & > .flexbox-fix {
      padding-right: 35px !important;
      & > div {
        height: 25px !important;
      }
    }
  }
`;

export const MobileResetButton = styled.button`
  position: absolute;
  right: 3px;
  bottom: -2px;
  background-color: transparent;
  border: none;
  padding: 0px;
  color: grey;
  i {
    font-size: 24px;
  }
`;

export const PaletteWrapper = styled.div`
  display: block;
  position: relative;
  width: 100%;
  margin-top: 10px;
  .sketch-picker {
    min-width: 100% !important;
    padding: 0px !important;
    display: flex;
    flex-direction: column;
    width: 98% !important;
    box-shadow: none !important;
    max-width: 100% !important;

    & > div:last-of-type,
    & > :nth-of-type(3) {
      display: none !important;
    }

    & > div:first-of-type {
      max-height: 130px;
      padding-bottom: 0 !important;
      height: 130px;
    }

    & .saturation-white {
      position: absolute;
      inset: 0;
    }

    & .saturation-black {
      position: absolute;
      inset: 0;
    }

    & > .flexbox-fix {
      & > div {
        height: 25px !important;
      }
    }
  }
`;

export const FullDesktopWrapper = styled.div``;
